import { FunctionComponentElement, useMemo, useState } from "react";
import Data from "./data.json";
import "./avro.scss";
import { NodeInputProps } from "..";
import { v4 as uuidv4 } from "uuid";
import { WidgetAvro } from "./widgetAvro";
import { ErrorDefaultValueWidget } from "../../error/errorDefaultValueWidget";

export interface Type {
  id: string;
  name: string;
  type: any;
}

export interface SchemaAvro {
  type: string;
  name: string;
  fields: Type[];
}

export const AvroInput = ({
  defaultValue,
  value,
  onChange,
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
  const [incorrectDefaultValue, setIncorrectDefaultValue] =
    useState<boolean>(false);

  const verifyType = (value: any) => {
    if (
      Object.keys(value).length === 3 &&
      typeof value?.name === "string" &&
      typeof value?.type === "string" &&
      Array.isArray(value?.fields)
    ) {
      for (let i of value.fields) {
        if (
          Object.keys(i).length !== 2 ||
          typeof i?.name !== "string" ||
          (typeof i?.type !== "string" && typeof i?.type !== "object")
        ) {
          return false;
        }
      }
    } else {
      return false;
    }
    return true;
  };

  const initValueForWidgetAvro = (nodeValues: SchemaAvro) => {
    return nodeValues.fields.map((val) => ({
      id: uuidv4(),
      name: val.name,
      type: val.type,
    }));
  };

  const [items, setItems] = useState(() => {
    if (value) return initValueForWidgetAvro(JSON.parse(value));
    if (defaultValue) {
      try {
        const defaultValueParsed = JSON.parse(defaultValue);
        if (verifyType(defaultValueParsed))
          return initValueForWidgetAvro(defaultValueParsed);
        else setIncorrectDefaultValue(true);
      } catch {
        setIncorrectDefaultValue(true);
        return [];
      }
    }
    return [];
  });

  return (
    <>
      <div>
        <ErrorDefaultValueWidget
          displayError={incorrectDefaultValue}
        ></ErrorDefaultValueWidget>
        <WidgetAvro
          setIncorrectDefaultValue={(value) => setIncorrectDefaultValue(value)}
          items={items}
          setItems={(valueUpdated) => setItems(valueUpdated)}
          onChange={(value) =>
            onChange(
              JSON.stringify({
                ...Data,
                fields: value.map((val) => ({
                  name: val.name,
                  type: val.type,
                })),
              }),
              value
            )
          }
        />
      </div>
    </>
  );
};
